import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"

const Tabla = ({ templateBooleanIcon, datos }) => {
    return (
        <div className="tabla-scroll-wrapper">
            <DataTable
                value={datos}
                stripedRows
                responsiveLayout="scroll"
                scrollable
                scrollHeight="calc(100vh - 310px)"
               
                emptyMessage="No se encontraron resultados"
            >
                <Column field="ID_BITACORA" header="ID" />
                <Column field="OPERADOR" header="Operador" />
                <Column field="TIPO_SERVICIO" header="Tipo servicio" />
                <Column field="RUTA" header="Ruta" />
                <Column field="TIPO" header="Tipo" />
                <Column field="TOTAL_KILOMETROS" header="KM Total" />
                <Column field="UNIDAD_TIPO" header="Tipo Unidad" />
                <Column field="NUMERO_VIAJE" header="No. Viajes" />
                <Column field="PAGO_UNITARIO_CHOFER" header="Pago Unitario Chofer" />
                <Column field="PAGO_TOTAL_CHOFER" header="Pago Total Chofer" />
                <Column field="SUELDO_GARANTIA" header="Sueldo Garantía" />
                <Column field="DIAS_TRABAJADOS" header="Días" />
                <Column
                    field="domingo"
                    header="Domingos"
                    body={(row) => templateBooleanIcon(row.TRABAJA_DOMINGOS)}
                />
            </DataTable>
        </div>
    )
}
export default Tabla